import React from "react";
import { Card, Typography, Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledCard = styled(Card)(({ theme }) => ({
  padding: theme.spacing(2),
  margin: theme.spacing(1),
  backgroundColor: "#ffffff",
  boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
  borderRadius: "8px",
}));

const Label = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: "0.875rem",
  marginBottom: theme.spacing(0.5),
}));

const Value = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: "1rem",
  fontWeight: 500,
}));

const BalanceView = ({ currentRecord }) => {
  if (!currentRecord) return null;

  const { bank_id, month, opening_balance, closing_balance } = currentRecord;

  return (
    <StyledCard>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <Label>Bank Name</Label>
          <Value>{bank_id?.bank_name || "N/A"}</Value>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Label>Month</Label>
          <Value>{month || "N/A"}</Value>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Label>Opening Balance</Label>
          <Value>${opening_balance?.toLocaleString() || "0"}</Value>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Label>Closing Balance</Label>
          <Value>${closing_balance?.toLocaleString() || "0"}</Value>
        </Grid>
      </Grid>
    </StyledCard>
  );
};

export default BalanceView;
